<template>
    <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card light>
            <v-card-title>
                <div>
                    <h3 class="headline mb-0 green--text">Agregar Evidencia</h3>
                </div>
            </v-card-title>
            <v-card-text class="p-relative">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-select
                            :items="evidencesTypes"
                            label="Tipo"
                            single-line
                            light
                            item-text="text"
                            item-value="value"
                            ref="type"
                            v-model="form.type"></v-select>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="form.placeholder_es"
                            label="Placeholder (Español)"
                            color="green"
                            :rules="rules.required"
                            ref="placeholder_es"
                            light
                            required>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="form.placeholder_en"
                            label="Placeholder (Ingles)"
                            color="green"
                            :rules="rules.required"
                            ref="placeholder_en"
                            light
                            required>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="form.description_es"
                            label="Descripción (Español)"
                            color="green"
                            :rules="rules.required"
                            ref="description_es"
                            light
                            required>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            v-model="form.description_en"
                            label="Descripción (Ingles)"
                            color="green"
                            :rules="rules.required"
                            ref="description_en"
                            light
                            required>
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat @click="close">Cancelar</v-btn>
                <v-btn color="green darken-1" flat @click="save">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'AddEvidenceModal',
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            evidencesTypes: [
                { value: 'text', text: 'text' },
                { value: 'textarea', text: 'textarea' },
                { value: 'image', text: 'image' },
                { value: 'map', text: 'map' },
                { value: 'question', text: 'question' },
                { value: 'radio_list', text: 'radio_list' },
                { value: 'checkbox_list', text: 'checkbox_list' },
                { value: 'select_list', text: 'select_list' },
                { value: 'select_list_related', text: 'select_list_related' },
                { value: 'select_list_other', text: 'select_list_other' },
            ],
            form: {
                type: null,
                placeholder_es: '',
                placeholder_en: '',
                description_es: '',
                description_en: ''
            },
            rules: {
                required: [
                    val =>  ((val === 0 ? '0' : String(val)) || '').length > 0 || 'Este campo es obligatorio'
                ]
            }
        }
    },
    methods: {
        ...mapActions([
            'addEvidence',
            'loadSponsorship'
        ]),
        close() {

            this.clearForm();
            this.$emit('close');
        },
        clearForm() {

            Object.keys( this.form ).forEach( key => this.form[ key ] = '');
        },
        save() {
            
            this.$refs.type.validate( true );
            this.$refs.placeholder_es.validate( true );
            this.$refs.placeholder_en.validate( true );
            this.$refs.description_es.validate( true );
            this.$refs.description_en.validate( true );

            if ( !this.$refs.type.valid || !this.$refs.placeholder_es.valid
                || !this.$refs.placeholder_en.valid || !this.$refs.description_es.valid
                || !this.$refs.description_en.valid ) {
                return;
            }

            const data = {
                ...this.form,
                sponsorship_id: this.$route.params.id
            }

            this.addEvidence({ data, callback: () =>
                this.loadSponsorship({ id: data.sponsorship_id, callback: () => this.close() }) });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/sponsorships/addEvidenceModal.vue